import React from 'react';
import { Flex } from '@chakra-ui/react';
import { ISubmissionFile } from '@publishing-engine/domain/models';
import { ButtonIcon, useToast } from '@morressier/alembic';
import { downloadFile } from 'src/utils/file';
import { isLocal } from '../../../../utils/env';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDownToBracket } from '@fortawesome/pro-regular-svg-icons';
import FileViewerButtonText from 'src/components/Submission/FileViewerButtonText';

type IProps = {
  files: ISubmissionFile[];
  filenameDisplay?: 'referenceName' | 'fileName';
  buttonIcon?: boolean;
  submissionContextId?: string;
};

export const FileListDisplay: React.FC<IProps> = ({ files, submissionContextId }) => {
  if (!files) return;

  const toast = useToast();

  return (
    <Flex
      flexDirection={'column'}
      marginLeft="1rem"
      textStyle="headingItem"
      as={'ol'}
    >
      {files.map(file => {
        return (
          <Flex
            key={file.id || file.url}
            flexDirection="row"
            justifyContent="space-between"
            backgroundColor="surfacePrimaryFill"
            paddingY={2}
            as={'li'}
            sx={{ display: 'list-item', paddingX: '0' }}
          >
            <Flex alignItems="center" gap={2} flexDirection="row">
              <FileViewerButtonText
                file={file}
                submissionContextId={submissionContextId}
                textStyle="textBody"
                wordBreak={'break-word'}
                whiteSpace="normal"
                textAlign={'start'}
              >
                {file.name}
              </FileViewerButtonText>

              <ButtonIcon
                icon={<FontAwesomeIcon icon={faArrowDownToBracket} />}
                ariaLabel="Download file"
                onClick={() => {
                  downloadFile(file.url).catch(_e => {
                    toast({
                      variant: 'error',
                      title: 'Error',
                      description: `Failed to obtain access to the file.${
                        isLocal ? ' Are you port-forwarding to asset-api?' : ''
                      }`,
                      isClosable: true
                    });
                  });
                }}
              ></ButtonIcon>
            </Flex>

            <Flex flexDirection={'row'} gap={8}></Flex>
          </Flex>
        );
      })}
    </Flex>
  );
};
